// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__ChJB6","selects":"Documents_selects__1JILF"};